import { makeAutoObservable } from "mobx";

export class SettingsStore {
  private _persistChat: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  public setPersistChat = (persist: boolean) => {
    this._persistChat = persist;
  };

  public get persistChat(): boolean {
    return this._persistChat;
  }
}
